import React from "react";
import { ClipLoader } from "react-spinners";
import logo from "../assets/logo/Artboard 1 copy 2@4x.png";

export default function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/90 z-[9999]">
      <div className="relative flex items-center justify-center">
        {/* السبينر الأبيض */}
        <ClipLoader color="#fff" size={120} speedMultiplier={0.8} />

        {/* اللوجو في النص */}
        <img
          src={logo}
          alt="Redcore Logo"
          className="absolute w-10 h-10"
        />
      </div>
    </div>
  );
}
